<template minapp='mpx' xlang='wxml'>
  <es-card layout="{{['header']}}" custom-header='es-content__miniapp_card_header' custom-body='es-content__miniapp_card_body'>
    <view slot='header' class="student-card-title">
      <view>学生购票说明</view>
      <view class="student-card-more" bindtap="jumpToComment">更多说明<es-icon size="16" class="es-content__name-info" name="angle-right" color="#212121"/></view>
    </view>
    <view class="student-card-list">
      <view wx:for="{{commentList}}" class="student-card-item">
        <view class="student-card-label">{{item.label}}</view>
        <view class="student-card-value" wx:if="{{item.isArray}}">
          <view class="student-card-value-item" wx:for="{{item.value}}" wx:for-item="vItem">{{vItem}}</view>
        </view>
        <view class="student-card-value" wx:else>{{item.value}}</view>
      </view>
    </view>
  </es-card>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { innerRouter, pagePath } from "@/common/jump";
  createComponent({
    classes: [],
    data: {
      commentList: [
        {
          label: '乘车时间',
          isArray: false,
          value: '每学年(10月1日至次年9月30日)可购买家庭居住地至院校(实习地点)所在地之间四次单程的学生优惠票'
        },
        {
          label: '优惠座席',
          sArray: false,
          value: '二等座、硬座、硬卧、无座'
        },
        {
          label: '优惠价格',
          isArray: true,
          value: [
            '二等座：7.5折',
            '硬卧：硬卧全价-50%硬座价格',
            '硬座：5折'
          ]
        },
        {
          label: '乘车区间',
          isArray: false,
          value: '必须与学生证优惠区间路段一致'
        }
      ]
    },
    props: {
      
    },
    computed: {

    },
    methods: {
      jumpToComment() {
        innerRouter.push(pagePath().ICKETPURCHASENOTICE, {
          checkTabIndex: 'student'
        })
      }
    }
  })
</script>

<style lang='stylus' scoped>
.student-card
  &-title
    display flex
    align-items center
    justify-content space-between
  &-list
    margin 12px 0 4px 0
  &-more
    display flex
    align-items center
    font-weight 400
    font-size 12px
  &-item
    display flex
    align-items flex-start
    margin-bottom 16px
  &-label
    width 56px
    font-size 14px
    color #999
    margin-right 40px
  &-value
    flex 1
    font-size 14px
    color #333
    line-height 18px
  &-value-item
    margin-bottom 8px
</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'es-card': '@didi/es-mpx-ui/lib/card',
    }
  }
</script>

